import { SecretsManagerService } from './service'

export namespace SecretsManagerServer {
  export const service = SecretsManagerService
}
